import React, { PropTypes } from 'react'

import './ServiceSummary.scss'

import { formatDate, format24hTime } from 'utils/dates'
import { serviceTypes } from '@src/globals'

const weekdaysNameTranslations = {
  'monday': 'Lunes',
  'tuesday': 'Martes',
  'wednesday': 'Miércoles',
  'thursday': 'Jueves',
  'friday': 'Viernes',
  'saturday': 'Sábado',
  'sunday': 'Domingo'
}

const ServiceSummary = ({ date, time, estimatedHours, promoCode, serviceTypeId, weekdays, urgent }) => {
  const serviceDateFormat = 'D [de] MMMM'
  const serviceDate = formatDate(serviceDateFormat, date)

  const serviceTime = format24hTime(time)

  const serviceWeekdayFormat = 'dddd'
  const serviceWeekday = formatDate(serviceWeekdayFormat, date)

  const serviceWeekdays = weekdays.map(weekday => weekdaysNameTranslations[weekday]).join(', ')

  function frequencySummary () {
    switch (serviceTypeId) {
      case serviceTypes.ONE_TIME.id:
        return `Una sola vez`

      case serviceTypes.MULTIPLE.id:
        return `Todos los ${serviceWeekdays}`

      case serviceTypes.WEEKLY.id:
      default:
        return `Cada ${serviceWeekday}`
    }
  }


  return (
    <div className='ServiceSummary'>
      <div className='SecondTimeBookingConfirmation-cardSection keyValuePair'>
        <label>Fecha de inicio</label>
        <p>{serviceDate}</p>
      </div>

      {!urgent && <div className='SecondTimeBookingConfirmation-cardSection keyValuePair'>
        <label>Hora del servicio</label>
        <p>{serviceTime}</p>
      </div>}

      <div className='SecondTimeBookingConfirmation-cardSection keyValuePair'>
        <label>Horas solicitadas</label>
        <p>{estimatedHours} horas</p>
      </div>

      {!urgent && <div className='SecondTimeBookingConfirmation-cardSection keyValuePair SecondTimeBookingConfirmation-cardSection-frequency'>
        <label>Frecuencia</label>
        <p>{frequencySummary()}</p>
      </div>}

      {
          promoCode.promotionName &&
          <div className='SecondTimeBookingConfirmation-cardSection keyValuePair ServiceSummary-promo'>
            <label>Descuento por promoción</label>
            <p>{promoCode.promotionName}</p>
          </div>
      }
    </div>
  )
}

ServiceSummary.displayName = 'ServiceSummary'
ServiceSummary.propTypes = {
  date: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
  estimatedHours: PropTypes.number.isRequired,
  promoCode: PropTypes.shape({
    promotionName: PropTypes.string
  })
}
ServiceSummary.defaultProps = {}

export default ServiceSummary



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/BookingConfirmation/screens/SecondTimeBookingConfirmation/components/ServiceSummary/ServiceSummary.js